if(typeof _.forIn === 'undefined') { var e = new Error("Cannot find module '_.forIn'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = _.forIn;